import { Link, Navigate, useParams } from "react-router-dom";
import Header from "@/components/Header";
import Seo from "@/components/Seo";
import ContactBar from "@/components/ContactBar";
import ContactForm from "@/components/ContactForm";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import BookCallButton from "@/components/BookCall";
import { LongArrow } from "@/components/Icons";
import Reveal from "@/components/Reveal";
import { sz, txt, useContent } from "@/content/ContentContext";
import { buildBlogPostFaqs, resolveFaqs } from "@/content/faqData";
import { blogPostMeta, blogPostingSchema, breadcrumbSchema } from "@/content/seoData";

const BlogPost = () => {
  const { slug } = useParams();
  const c = useContent();
  const post = c.blog.posts.find((entry) => entry.slug === slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="App">
      <Seo
        title={blogPostMeta(post).title}
        description={blogPostMeta(post).description}
        path={`/blog/${post.slug}`}
        type="article"
        image="/assets/workspace.jpg"
        article={{
          publishedTime: (() => {
            const d = new Date(txt(post.date));
            return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
          })(),
          section: txt(post.category),
          author: "IT Device Services",
        }}
        schemas={[
          blogPostingSchema(post),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Blog", path: "/blog" },
            { name: blogPostMeta(post).title, path: `/blog/${post.slug}` },
          ]),
        ]}
      />
      <Header />
      <main>
        <section className="svcpage-hero">
          <Reveal className="svcpage-hero-inner" y={18}>
            <Link to="/blog" className="post-back" data-testid="back-to-blog">
              <LongArrow className="post-back-arrow" />
              ALL POSTS
            </Link>
            <div className="blog-meta post-meta">
              <span style={sz(post.date)}>{txt(post.date)}</span>
            </div>
            <h1 className="svcpage-title post-title" style={sz(post.title)} data-testid="post-title">
              {txt(post.title)}
            </h1>
          </Reveal>
        </section>

        <section className="post-body">
          <Reveal as="article" className="post-content" data-testid="post-content" y={22}>
            {post.paragraphs.map((paragraph, paragraphIndex) => (
              <p className="post-para" key={paragraphIndex}>
                {paragraph}
              </p>
            ))}
            <BookCallButton className="btn-dark post-cta" testId="post-cta" />
            <a
              href="#message"
              className="alt-contact-link"
              style={sz(c.global.altContactLabel)}
              data-testid="post-alt-contact"
            >
              {txt(c.global.altContactLabel)}
            </a>
          </Reveal>
        </section>
      </main>
      <FAQSection items={resolveFaqs(c, `blogpost:${post.slug}`, buildBlogPostFaqs(post, c))} />
      <ContactForm />
      <ContactBar />
      <Footer />
    </div>
  );
};

export default BlogPost;
